export enum AdditionalRole {
  SINGLE_ZONE = "SINGLE_ZONE",
  MULTI_ZONE = "MULTI_ZONE",
  NONE = "NONE",
}

export const additionalRoleLabel = {
  SINGLE_ZONE: "ดูแลแบบเขตเดียว",
  MULTI_ZONE: "ดูแลแบบหลายเขต",
  NONE: "ไม่มี",
};
export enum AdditionalRoleSetting {
  NAV_DOC = "NAV_DOC",
  NONE = "NONE",
}

export const additionalRoleSettingLabel = {
  NAV_DOC: "ประเภทเอกสาร NAV",
  NONE: "ไม่มี",
};
